const navToggle = document.querySelector('#hammyBtn')

navToggle.addEventListener('click', () => {
	document.body.classList.toggle('nav-is-open')
})